(function() {
    'use strict';
    angular.module('tmx-app').factory('LocationTreeService',['$mdSidenav','tmxResource', 

        function LocationTreeService($mdSidenav,tmxResource) {

		
            var LocationTree = {};
            LocationTree.loadTreeData=function(){
                Locations.all().then(function(result){
                    LocationTree.LocationTreeGrid.pop();
                    for(var i=0; i<result.length; i++) {
                        LocationTree.LocationTreeGrid.push(result[i]);
                    }
                });
            };
            var Locations = tmxResource("Location/tree");
            LocationTree.LocationTreeGrid =  new kendo.data.ObservableArray([
                { 
                    LocationId:	0 , 
                    LocationName:	"Locations" , 
                    LocationCode:	"000" , 
                    Children	:	[]
                }
            ]);
            LocationTree.loadTreeData();
            LocationTree.treeData = new kendo.data.HierarchicalDataSource(
                { 
                    data: LocationTree.LocationTreeGrid,
                    schema: 
{
    model: 
{
    hasChildren: function(dataItem){ if(dataItem.Children.length>0) return true; else return false; },
    children: "Children"
}
}
                }
            );

            LocationTree.refreshTreeData=function(){
                LocationTree.loadTreeData();
            };


            LocationTree.getLocationTreeOArray=function(){
                return LocationTree.LocationTreeGrid;
            };

            LocationTree.toggle = function(navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function() {
                    });
            };
            LocationTree.isOpen = function(navID) {
                return $mdSidenav(navID).isOpen();
            };
            LocationTree.close = function(navID) {
                $mdSidenav(navID).close()
                    .then(function() {
                    });
            }; 

            return LocationTree;
        }]);
})();